import { ChangeEvent, FunctionComponent } from 'react';
import { Steps } from '../../core/services/analytics/module';
import uppercaseFirst from '../../utilities/uppercaseFirst';
import { TransactionFieldProps } from './TransactionField';
import styles from './BillingFrequency.module.scss';

export const UseCardOnFile: FunctionComponent<TransactionFieldProps> = ({
	field,
	className,
	changeHandler,
	analytics
}) => {
	const onChange = (e: ChangeEvent<HTMLElement>) => {
		const input = e.target as HTMLInputElement;
		if (input.checked) {
			field.SetValue(input.value);

			analytics?.TrackCheckoutOption({
				ecommerce: {
					checkout_option: {
						actionField: {
							step: Steps.Four,
							option: uppercaseFirst(input.value)
						}
					}
				}
			});
		}
		changeHandler?.(e);
	};

	return <>
		<div className={styles.radioButtonWrapper}>
			<input
				type="radio"
				id="useCardOnFile_yes"
				name="useCardOnFile"
				value="yes"
				className={`${styles.radioButton} ${className}`}
				defaultChecked={true}
				onChange={onChange}
				data-testid="UseCardOnFileYes"
			/>
			<label htmlFor="useCardOnFile_yes" className={styles.label}>
				Yes, continue with purchase
			</label>
		</div>

		<div className={styles.radioButtonWrapper}>
			<input
				type="radio"
				id="useCardOnFile_no"
				name="useCardOnFile"
				value="no"
				className={`${styles.radioButton} ${className}`}
				defaultChecked={false}
				onChange={onChange}
				data-testid="UseCardOnFileNo"
			/>
			<label htmlFor="useCardOnFile_no" className={styles.label}>
				No thanks, I'll use another form of payment
			</label>
		</div>
	</>;
};
